import { useEffect, useState } from 'react';
import { forgotPassword } from '../../assets/constants/global_apis';
import { useNavigate } from 'react-router-dom';
import { GradientCircularProgress } from '../Loader';

export default function ForgotPassword({ triggerAlert, setCurrentPage }) {
  // const toast  = useRef(null);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate=useNavigate()

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  useEffect(() => {
    try {
      localStorage.removeItem('authtoken');
      localStorage.removeItem('role');
      localStorage.removeItem('email');
    } catch (e) {
      console.error('User not logged in');
    }
  })

  const handleSubmit = (e) => {
    setLoading(true)
    e.preventDefault();
      forgotPassword(email).then((response) => {
        localStorage.setItem('email', email);
          setLoading(false)
          triggerAlert('Success', 'OTP sent successfully');
          setCurrentPage('/validate-otp');
          navigate('/validate-otp');
      }).catch((err) => {
        setLoading(false)
        triggerAlert('Error', err.message);
      });
  };

  return (
    <><form role="form" className="text-start"
      onSubmit={handleSubmit}
    >
      <div>
        <label>Email</label>
        <div className="mb-3">
          <input
            className="form-control"
            aria-label="UserName"
            type="email"
            name="email"
            value={email}
            placeholder="Enter Email"
            required
            onChange={handleChange}
          /> </div>
      </div>

      <div className="text-center">
        <button
          type="submit"
          className="btn bg-gradient-info w-100 mt-4 mb-0"
          disabled={loading}
        >
          {loading ? <GradientCircularProgress width={18} /> : 'Submit'}
          
        </button>
      </div>
    </form>
    </>
  );
}
